<template>
  <div class="app-container">
    <div class="data-view-wrap" v-show="list.length">
      <div
        class="item-wrap"
        v-for="(item, index) in inventoryItems"
        :key="index"
      >
        <div>{{ item.label }}</div>
        <div class="unit">
          <span>{{ item.value }}</span
          >{{ item.unit }}
        </div>
      </div>
    </div>
    <el-form :model="search" :inline="true" label-position="right" ref="search">
      <el-form-item label="网点编号" prop="outletsNo">
        <el-input v-model="search.outletsNo" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <!-- 本期只接收网点编号入参 -->
      <el-form-item label="网点名称" prop="outletsName">
        <el-input v-model="search.outletsName" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="省份" prop="provinceId">
        <el-input v-model="search.provinceId" placeholder="请输入" clearable></el-input>
      </el-form-item>
        <!-- <el-select
          v-model="search.provinceId"
          placeholder="请选择"
          clearable
          style="width:100%"
          @change="getTblCity"
        >
          <el-option
            v-for="item in provinceList"
            :key="item.sfid"
            :label="item.sfen"
            :value="item.sfen"
            style="width:100%"
          >
          </el-option>
        </el-select> -->
      <el-form-item label="城市" prop="cityId">
        <el-input v-model="search.cityId" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <!-- <el-form-item label="城市" prop="cityId">
        <el-select
          v-model="search.cityId"
          placeholder="请选择"
          clearable
          style="width:100%"
          :disabled="!search.provinceId"
          @change="getTblCounty"
        >
          <el-option
            v-for="item in cityList"
            :key="item.ciid"
            :label="item.city"
            :value="item.city"
            style="width:100%"
          >
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="区" prop="districtId">
        <el-input v-model="search.districtId" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <!-- <el-form-item label="区" prop="districtId">
        <el-select
          v-model="search.districtId"
          placeholder="请选择"
          clearable
          style="width:100%"
          :disabled="!search.cityId"
        >
          <el-option
            v-for="item in countyList"
            :key="item.coid"
            :label="item.county"
            :value="item.county"
            style="width:100%"
          >
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="联系人" prop="outletsContact">
        <el-input v-model="search.outletsContact" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="联系人电话" prop="outletsPhone">
        <el-input v-model="search.outletsPhone" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="所属区域" prop="regionName">
        <el-input v-model="search.regionName" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="是否有待回收旧机" prop="field">
        <el-select
          v-model="search.existAwaitRecycleTotal"
          placeholder="请选择"
          clearable
          style="width:100%"
        >
          <el-option
            v-for="(val, key) in hasOldOPtion"
            :key="key"
            :label="val"
            :value="key"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="row-bg">
      <!-- 导出本期不做 -->
      <!-- <el-button type="primary" size="medium" @click="exportExcel()">导出</el-button> -->
      <el-button type="primary" size="medium" @click="getList()"
        >查询</el-button
      >
      <el-button size="medium" @click="resetForm()">重置</el-button>
      <el-button size="medium" @click="exportExcel">导出</el-button>
    </div>
    <el-table
      ref="checktableData"
      :data="list"
      v-loading="listLoading"
      :reserve-selection="true"
      center
      height="60vh"
    >
      <el-table-column
        label="网点编号"
        prop="outletsNo"
        width="80"
      ></el-table-column>
      <el-table-column
        label="网点名称"
        prop="outletsName"
        width="120"
      ></el-table-column>
      <el-table-column
        label="所属区域"
        prop="regionName"
        width="120"
      ></el-table-column>
      <el-table-column
        label="未入库旧机总数"
        prop="notWarehousingTotal"
        width="120"
      ></el-table-column>
      <el-table-column
        label="可回收总数"
        prop="awaitRecycleTotal"
        width="120"
      ></el-table-column>
      <el-table-column
        label="回收中总数"
        prop="underwayRecycleTotal"
        width="120"
      ></el-table-column>
      <el-table-column
        label="已回收总数"
        prop="alreadyRecycleTotal"
        width="120"
      ></el-table-column>
      <el-table-column label="是否有待回收旧机" min-width="120" align="center">
        <template slot-scope="scope">{{ scope.row.existAwaitRecycleTotal === 0 ? '否' : '是' }}</template>
      </el-table-column>
      <el-table-column
        label="省"
        min-width="100"
        align="center"
        prop="province"
      >
      </el-table-column>
      <el-table-column label="市" prop="city" width="100"></el-table-column>
      <el-table-column label="区" prop="district" width="100"></el-table-column>
      <el-table-column
        label="详细地址"
        prop="address"
        width="200"
      ></el-table-column>
      <el-table-column
        label="联系人"
        prop="outletsContact"
        width="120"
      ></el-table-column>
      <el-table-column
        label="联系电话"
        prop="outletsPhone"
        width="120"
      ></el-table-column>
      <el-table-column label="操作" fixed="right" width="150" align="center">
        <template slot-scope="scope">
          <!-- <el-button type="text" @click="goEdit(scope.row.id)">查看</el-button> -->
          <el-button type="text" @click="goAdd(scope.row,'add')">回收</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="search.pageNum"
        :page-size="search.pageSize"
        :page-sizes="[10, 20]"
        :total="total"
      >
      </el-pagination>
    </div>
    <appointmentDialog
      ref="AddDialogRef"
      @opera-success="getList"
    ></appointmentDialog>
  </div>
</template>
<script>
import appointmentDialog from "./components/appointmentDialog";
import { getOldMachineRepertoryList } from "@/api/oldForNew";
export default {
  name: "inventory",
  components: {
    appointmentDialog
  },
  data() {
    return {
      inventoryItems: [
      { label: "未入库旧机总数", value: "--", unit: "套" },
        { label: "可回收总数", value: "--", unit: "套" },
        {
          label: "回收中总数",
          value: "--",
          unit: "套"
        },
        { label: "已回收总数", value: "--", unit: "套" }
      ],
      list: [],
      total: 0, //列表总条数
      listLoading: false,
      search: {
        outletsNo: "", //网点编码
        outletsName: "", //
        provinceId: null, //省
        cityId: null, //市
        districtId: null, //区
        outletsContact: '',  // 网点联系人
        outletsPhone: '',  // 网点联系人电话
        existAwaitRecycleTotal: null, // 是否有待回收
        regionName:null,//所属区域
        currPage: 1, //当前页
        pageSize: 10
      },
      hasOldOPtion: { 1: "是", 0: "否" }, //是否有待回收旧机
      provinceList: [], //省份列表
      cityList: [], //市列表
      countyList: [], //区域列表
      exportParams:{}
    };
  },
  async created() {
    this.getTblProvince();
    this.getList()
  },
  methods: {
    resetForm() {
      this.search = this.$options.data().search;
    },
    async getList() {
      this.list = [];
      // let province = this.provinceList.filter(item => item.sfen === this.search.provinceId)
      // let city = this.cityList.filter(item => item.city === this.search.cityId)
      // let county = this.countyList.filter(item => item.county === this.search.districtId)
      // console.log('获取省份id', province)
      // return
      let params = {}
      params.outletsNo = this.search.outletsNo
      params.outletsName = this.search.outletsName
      params.province =  this.search.provinceId
      params.city =  this.search.cityId
      params.district =  this.search.districtId
      params.outletsContact = this.search.outletsContact
      params.outletsPhone = this.search.outletsPhone
      params.existAwaitRecycleTotal = this.search.existAwaitRecycleTotal
      params.page  = this.search.pageNum
      params.rows = this.search.pageSize
      params.regionName=this.search.regionName
      this.exportParams = params
        let { statusCode, data, total } = await getOldMachineRepertoryList(
        params
        );
        if (statusCode == 200) {
          this.list = data || [];
          this.total = total || 0
          this.getTotal(params)
        }
    },
    //打开提交回收单窗口
    goAdd(row) {
      console.log('打开弹框数据', row)
      this.$refs.AddDialogRef.openDialog(row,'add');
    },
    handleSizeChange(val) {
      this.search.pageNum = 1;
      this.search.pageSize = val;
      this.getList();
    },
    handleCurrentChange() {
      this.getList();
    },
    //导出
    exportExcel() {
      // this.global.exportExcel
      //     (`/autoapp-default-server-recovery/api/oldMachineRecovery/export/getRecoveryApplyByOutletsNo`, this.exportParams, '网点旧机库存表', 'post').catch((res) => {
      //       let blob = new Blob([res.response.data], {
      //         type: 'application/json',
      //       });
      //       var blobReader = new Response(blob).json();
      //       blobReader.then((res) => {
      //         this.$message.error(res.message);
      //       });
      //     });

      const url = `/autoapp-default-server-recovery/api/oldMachineRecovery/export/getRecoveryApplyByOutletsNo`;
      this.HttpService.post(url, this.exportParams).then(res => {
        if (res.statusCode == 200) {
          this.$message.success('正在导出, 稍后请到下载中心查看')
        } else {
          this.$message.warning(res.message)
        }
      })
    },

    // 获取总数
    async getTotal(params) {
        this.HttpService.post(
          `/autoapp-default-server-recovery/api/oldMachineRecovery/getOutletsOldMachineStatistics`,params
        ).then(res => {
          if (res.statusCode === 200) {
          this.inventoryItems[0].value = res.data.notWarehousingTotal || 0;
          this.inventoryItems[1].value = res.data.awaitRecycleTotal || 0;
          this.inventoryItems[2].value = res.data.underwayRecycleTotal || 0;
          this.inventoryItems[3].value = res.data.alreadyRecycleTotal || 0;
          console.log('获取总数',res)
        }
        });
    },
    //获取省份列表
    getTblProvince() {
      this.search.cityId = "";
      this.search.districtId = "";
      return this.HttpService.get(
        `/autoapp-default-server-recovery/api/tbl-province/getTblProvince`
      ).then(res => {
        if (res.statusCode === 200) {
          this.provinceList = res.data;
        }
      });
    },
     //根据省份获取城市列表
    getTblCity() {
      this.search.cityId = "";
      this.search.districtId = "";
      return this.HttpService.get(
        `/autoapp-default-server-recovery/api/tbl-city/getTblCity?sfen=${this.search.provinceId}`
      ).then(res => {
        if (res.statusCode === 200) {
          this.cityList = res.data;
        }
      });
    },
    //根据省市获取区域列表
    getTblCounty() {
      this.search.districtId = "";
      return this.HttpService.get(
        `/autoapp-default-server-recovery/api/tbl-county/getTblCounty?city=${this.search.cityId}`
      ).then(res => {
        if (res.statusCode === 200) {
          this.countyList = res.data;
        }
      });
    },
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.goodsStyle {
  display: flex;
  align-items: center;
}
.flex {
  display: flex;
  align-items: center;
  // margin: 0 20px;
  padding: 0 20px;
  span {
    min-width: 100px;
  }
}
.row-bg {
  margin-bottom: 15px;
}
.btnBox {
  margin-bottom: 20px;
}
.data-view-wrap {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-start;
  .item-wrap {
    margin-right: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #00b882;
    padding: 10px;
    height: auto;
    color: #fff;

    .unit {
      margin-left: 20px;
      max-width: 300px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      > span {
        font-size: 20px;
        padding-right: 5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/oldForNewService/inventory.vue